import { getAttributeOrThrow } from '../@widgets/@dom/get-attribute-or-throw';
import { getElementOrThrow } from '../@widgets/@dom/get-element-or-throw';
import { MH_API_URL, MH_SCRIPT_API_ATTRIBUTE, MH_SCRIPT_PROGRAM_ATTRIBUTE } from '../shared/constants';
import type { Mh } from '../shared/interfaces';

export const createMh = async () => {
    const mhElement = getElementOrThrow<HTMLScriptElement>(`[${MH_SCRIPT_PROGRAM_ATTRIBUTE}]`);
    const programSlug = getAttributeOrThrow(mhElement, MH_SCRIPT_PROGRAM_ATTRIBUTE);
    const lastSlashIndex = mhElement.src.lastIndexOf(`/`);
    const scriptUrl = mhElement.src.substring(0, lastSlashIndex);
    const apiUrl = mhElement.getAttribute(MH_SCRIPT_API_ATTRIBUTE) ?? MH_API_URL;

    const mh: Mh = {
        apiUrl,
        programSlug,
        scriptUrl,
    };

    return mh;
};
